import { render } from "./editReturnWarehouse.vue?vue&type=template&id=3195e646&scoped=true&ts=true"
import script from "./editReturnWarehouse.vue?vue&type=script&lang=ts"
export * from "./editReturnWarehouse.vue?vue&type=script&lang=ts"

import "./editReturnWarehouse.vue?vue&type=style&index=0&id=3195e646&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3195e646"]])

export default __exports__